var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75H25C25.75 8.75 26.25 8.25 26.25 7.5C26.25 6.75 25.75 6.25 25 6.25H5C4.25 6.25 3.75 6.75 3.75 7.5C3.75 8.25 4.25 8.75 5 8.75Z",
    fill: "#F2EADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.25H25C25.75 16.25 26.25 15.75 26.25 15C26.25 14.25 25.75 13.75 25 13.75H12.5C11.75 13.75 11.25 14.25 11.25 15C11.25 15.75 11.75 16.25 12.5 16.25Z",
    fill: "#F2EADF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 23.75H25C25.75 23.75 26.25 23.25 26.25 22.5C26.25 21.75 25.75 21.25 25 21.25H7.5C6.75 21.25 6.25 21.75 6.25 22.5C6.25 23.25 6.75 23.75 7.5 23.75Z",
    fill: "#F2EADF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.e5201bc533678e1c8fa04b214661d6a5.svg";
export { ForwardRef as ReactComponent };